import {
  Box,
  Button,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Link,
  Typography,
  useTheme,
} from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import Confetti from 'react-confetti';
import { useLocation, useParams } from 'react-router-dom';
import Iconify from 'src/components/iconify';
import { LoadingScreen } from 'src/components/loading-screen';
import { useSettingsContext } from 'src/components/settings';
import { useBoolean } from 'src/hooks/use-boolean';
import { useMockedUser } from 'src/hooks/use-mocked-user';
import { useResponsive } from 'src/hooks/use-responsive';
import { RouterLink } from 'src/routes/components';
import { usePublicGetAllUsersQuery } from 'src/store/Reducer/settings';
import './index.css';
import {
  useGetGiveawayDetailsByIdQuery,
  useGetParticipantInGiveawayQuery,
} from 'src/store/Reducer/giveaway';
import { useLocales } from 'src/locales';

const visibleItemCount = 5;
const itemHeight = 80;
const centerOffset = Math.floor(visibleItemCount / 2);

const GiveawayResult = () => {
  const { t } = useLocales();
  const theme = useTheme();
  const { user } = useMockedUser();
  const isMobile = useResponsive('down', 'md');
  const { id } = useParams();
  const { state } = useLocation();
  const isDrawing = useBoolean();
  const openDialog = useBoolean();
  const showCelebration = useBoolean();

  const [countdown, setCountdown] = useState(5);
  const [winner, setWinner] = useState(null);
  const [slotPosition, setSlotPosition] = useState(itemHeight * centerOffset);
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  const isLightMode = theme.palette.mode === 'light';

  // const { data, isLoading } = usePublicGetAllUsersQuery({ id });

  let { data: giveawayDetail } = useGetGiveawayDetailsByIdQuery({ id });
  const { data: { data: participantInGiveaway = [] } = {}, isLoading } =
    useGetParticipantInGiveawayQuery({
      id: id,
    });

  // const winners = data?.data?.filter((item) => state?.winners?.includes(item._id));
  const settings = useSettingsContext();
  // const participants = useMemo(() => {
  //   if (!data?.data) return [];
  //   return data.data
  //     .filter((item) => !state?.winners?.includes(item?._id))
  //     .map((item) => ({
  //       name: `${item?.firstName || ''} ${item?.lastName || ''}`.trim(),
  //     }));
  // }, [data?.data, state?.winners]);
  //

  // const baseList = useMemo(() => {
  //   const base = [...participants];
  //   if (user?.firstName && user?.lastName) {
  //     base.push({ name: `${user.firstName} ${user.lastName}` });
  //   }
  //   return base;
  // }, [participants, user]);

  // const displayList = useMemo(() => {
  //   const base = [...baseList];

  //   // Shuffle array on each render to add true randomness
  //   for (let i = base.length - 1; i > 0; i--) {
  //     const j = Math.floor(Math.random() * (i + 1));
  //     [base[i], base[j]] = [base[j], base[i]];
  //   }

  //   if (base.length <= 3) {
  //     return Array(Math.ceil(6 / base.length))
  //       .fill(base)
  //       .flat()
  //       .slice(0, 6);
  //   }

  //   return base;
  // }, [baseList]);

  // const startSlotAnimation = () => {
  //   const allParticipants = [...displayList];
  //   const totalSpins = 50;
  //   const spinDurations = [];
  //   for (let i = 0; i < totalSpins - 3; i++) {
  //     spinDurations.push(50 + i * 6);
  //   }
  //   spinDurations.push(1000, 1000, 1000);

  //   let currentSpin = 0;

  //   const spinStep = () => {
  //     const displayIndex = currentSpin % allParticipants.length;
  //     const position =
  //       (displayIndex - centerOffset + allParticipants.length) % allParticipants.length;
  //     setSlotPosition(position * itemHeight);

  //     if (currentSpin < spinDurations.length) {
  //       setTimeout(spinStep, spinDurations[currentSpin]);
  //       currentSpin++;
  //     } else {
  //       const finalCenteredIndex = (position + centerOffset) % allParticipants.length;
  //       const finalWinner = allParticipants[finalCenteredIndex];
  //       setWinner(finalWinner?.name);
  //       setTimeout(() => {
  //         announceWinner(finalWinner?.name);
  //       }, 500);
  //     }
  //   };

  //   spinStep();
  // };

  // const announceWinner = (winner) => {
  //   openDialog.onTrue();
  // };

  // const startDrawing = () => {
  //   isDrawing.onTrue();
  //   setCountdown(5);
  // };

  // useEffect(() => {
  //   let countdownInterval;
  //   if (isDrawing.value) {
  //     countdownInterval = setInterval(() => {
  //       setCountdown((prev) => {
  //         if (prev === 1) {
  //           clearInterval(countdownInterval);
  //           setTimeout(() => {
  //             isDrawing.onFalse();
  //             startSlotAnimation();
  //           }, 1000);
  //         }
  //         return prev - 1;
  //       });
  //     }, 1000);
  //   }
  //   return () => clearInterval(countdownInterval);
  // }, [isDrawing.value]);

  // useEffect(() => {
  //   let hasSetWinner = false;
  //   if (!isDrawing.value && !hasSetWinner) {
  //     const centeredIndex = Math.round(slotPosition / itemHeight) + centerOffset;
  //     if (displayList?.[centeredIndex]) {
  //       setWinner(displayList[centeredIndex]?.name);
  //       hasSetWinner = true;
  //     }
  //   }
  // }, [slotPosition, isDrawing.value]);

  // useEffect(() => {
  //   if (openDialog.value) {
  //     showCelebration.onTrue();
  //     setTimeout(() => {
  //       showCelebration.onFalse();
  //     }, 10000);
  //   }
  // }, [openDialog.value]);

  // useEffect(() => {
  //   startDrawing();
  //   const handleResize = () => {
  //     setWindowSize({
  //       width: window.innerWidth,
  //       height: window.innerHeight,
  //     });
  //   };
  //   window.addEventListener('resize', handleResize);
  //   return () => window.removeEventListener('resize', handleResize);
  // }, []);

  const data = useMemo(() => {
    const winners = [];
    let winnerIndex = 0;
    const displayList = participantInGiveaway?.map((participant, indx) => {
      const name = `${participant?.firstName || ''} ${participant?.lastName || ''}`.trim();
      if (participant?.isWinner) {
        winners.push(name);
        winnerIndex = indx;
      }
      return { name };
    });
    return { winners, displayList, winnerIndex };
  }, [participantInGiveaway]);

  const { winners, displayList, winnerIndex } = data;
  useEffect(() => {
    if (winners?.length > 0) {
      showCelebration.onTrue();
      setTimeout(() => {
        showCelebration.onFalse();
      }, 10000);
    }
  }, [winners]);
  return (
    <>
      {isLoading ? (
        <LoadingScreen />
      ) : (
        <Container
          maxWidth={settings.themeStretch ? false : 1}
          sx={{
            position: 'relative',
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundImage: `url(/assets/images/${
                isLightMode ? 'logoLightMode.png' : 'backgroundImage.png'
              })`,
              backgroundSize: 'contain',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              opacity: isLightMode ? 0.1 : 1,
              zIndex: 0,
              pointerEvents: 'none',
            }}
          />
           {winners?.length === 0 && (
            <Typography sx={{ mb: 2 , textAlign: 'center' }} variant="h3" color={theme.palette.mode === 'light' ? 'black' : 'white'}>
             {t('home.await_result')}
            </Typography>
          )}
          {winners?.length !== 0 && (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                // mt: { xs: 2, md: -20 },
                mb: { xs: 2, md: 4 },
                width: 1,
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  // ml: { md: 4 },
                  width: { xs: '100%', md: '300px' },
                }}
              >
                <Typography variant="h3" sx={{ fontWeight: 'bold', mb: 2 }}>
                  {t('home.declared_winners')}
                </Typography>

                <Box
                  sx={{
                    width: '100%',
                    maxHeight: 400,
                    overflowY: 'auto',
                    backgroundColor: '#121212',
                    border: '1px solid #5ebe89',
                    borderRadius: 2,
                    p: 2,
                    boxShadow: '0 0 10px #5ebe89',
                  }}
                >
                  {winners?.map((item, idx) => (
                    <Typography key={idx} sx={{ color: '#5ebe89', mb: 1 }}>
                      {idx + 1}. {item}
                    </Typography>
                  ))}
                </Box>
              </Box>
            </Box>
          )}
          <header>
            <Typography
              fontSize={{
                // xs: '1.5rem',
                // md: '2rem',
                // lg: '2.5rem',
                textDecoration: 'none',
                color: theme.palette.mode === 'light' ? 'black' : 'white',
              }}
              variant="h3"
              fontWeight="bold"
              component={RouterLink}
              href="http://luckyads.app"
              target="_blank"
            >
              {/* Sponsored by <span >GameZone</span> */}
              {giveawayDetail?.data?.basicInfo?.title || t('home.giveaway_result')}
            </Typography>
            <div className="logo">
              <Box
                component={'img'}
                // src="/assets/images/giftImage.png"
                src={giveawayDetail?.data?.basicInfo?.image || '/assets/images/giftImage.png'}
                sx={{
                  mt: 2,
                  width: { xs: 120, md: 300 },
                  height: { xs: 120, md: 300 },
                  objectFit: 'cover',
                  borderRadius: 2,
                }}
              />
            </div>
          </header>
          <Box>
            {/* <Box
              sx={{
                width: { xs: 1, md: 0.3 },
                margin: '0 auto',
                border: '2px solid #5ebe89',
                borderRadius: '16px',
                boxShadow: '0 0 20px #5ebe89',
                overflow: 'hidden',
              }}
            >
              <div
                className="slot-machine"
                style={{ height: itemHeight * visibleItemCount, overflow: 'hidden' }}
              >
                <div className="slot-container">
                  <div className="slot-window">
                    {displayList.map((participant, index) => {
                      const currentCenteredIndex =
                        Math.round(slotPosition / itemHeight) + centerOffset;
                      const distanceFromCenter = Math.abs(index - currentCenteredIndex);

                      let itemClass = 'slot-item';
                      if (distanceFromCenter === 0) itemClass += ' highlight';
                      else if (distanceFromCenter === 1) itemClass += ' near-center';
                      else itemClass += ' outer';
                      return (
                        <div
                          className={itemClass}
                          key={index}
                          style={{
                            height: `${itemHeight}px`,
                            transform: `translateY(${index * itemHeight - slotPosition}px)`,
                            transition: 'transform 0.2s cubic-bezier(0.45, 0, 0.55, 1)', // smoother motion
                            position: 'absolute',
                            top: 0,
                            width: '100%',
                            textAlign: 'center',
                            zIndex: 10 - distanceFromCenter,
                            willChange: 'transform',
                          }}
                        >
                          <div className="participant-info">
                            <Box className="participant-name">{participant?.name}</Box>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
                {isDrawing.value && (
                  <div className="countdown-container">
                    <div className="countdown-circle"></div>
                    <div className="countdown-number">{countdown}</div>
                  </div>
                )}
              </div>
            </Box> */}
          </Box>
          <Box
            sx={{
              width: 1,
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
              mt: 2,
            }}
          >
            <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center' }}>
              {t('home.powered_by')}{' '}
              <Link
                component={RouterLink}
                href="https://chain.link/"
                target="_blank"
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  ml: 1,
                  textDecoration: 'none',
                  // color: 'white',
                }}
              >
                {' '}
                ChainLink{' '}
                <Iconify icon="simple-icons:chainlink" width={24} sx={{ color: 'blue', ml: 1 }} />
              </Link>
            </Typography>
          </Box>

          {/* <Dialog
            open={openDialog.value}
            onClose={() => openDialog.onFalse()}
            maxWidth="xs"
            fullWidth
            PaperProps={{
              sx: {
                backgroundColor: 'transparent',
                boxShadow: 'none',
                border: 'none',
              },
            }}
          >
            <Box
              sx={{
                backgroundImage: 'url(/assets/images/modalBackgroundImage.png)',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                boxShadow: 24,
                borderRadius: 2,
                width: 1,
                height: 1,
                backgroundColor: 'transparent',
              }}
            >
              <DialogTitle sx={{ fontWeight: 'bold', textAlign: 'center' }}>
                <Box
                  component="img"
                  src="/assets/images/winnerImage.png"
                  sx={{ width: { xs: 100, md: 150 }, height: { xs: 100, md: 150 } }}
                />
                <Typography
                  variant={isMobile ? 'h3' : 'h2'}
                  sx={{
                    textAlign: 'center',
                    textShadow: '1px 1px 4px rgba(0,0,0,0.3)',
                    color: 'white',
                    fontWeight: 'bold',
                    wordWrap: 'break-word',
                  }}
                >
                  Congratulations
                </Typography>
              </DialogTitle>
              <DialogContent
                sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
              >
                <Box>
                  <Typography
                    variant="h3"
                    component="h3"
                    color={'primary'}
                    sx={{
                      fontWeight: 'bold',
                      mb: 2,
                      textShadow: (theme) => `1px 1px solid 4px ${theme.palette.primary.main}`,
                      textAlign: 'center',
                    }}
                  >
                    {winner}
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    sx={{ opacity: 0.9, paddingBottom: 3, color: 'white', textAlign: 'center' }}
                  >
                    You are the lucky Winner!
                  </Typography>
                </Box>
              </DialogContent>
              <DialogActions>
                <Box
                  fullWidth
                  width={1}
                  sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                >
                  <Button
                    variant="contained"
                    size="large"
                    sx={{
                      width: 1,
                      backgroundColor: 'primary.main',
                      color: 'black',
                      '&:hover': {
                        backgroundColor: 'primary.main',
                      },
                    }}
                    onClick={openDialog.onFalse}
                  >
                    Continue
                  </Button>
                </Box>
              </DialogActions>
            </Box>
          </Dialog> */}
          {showCelebration.value && (
            <Confetti width={windowSize.width} height={windowSize.height} numberOfPieces={400} />
          )}
        </Container>
      )}
    </>
  );
};

export default GiveawayResult;
